import { BASE_PATH } from './Router.constants';

export function routePathPrefix(path: string) {
  return `${BASE_PATH}${path}`;
}
